import { render, staticRenderFns } from "./SafeForWork3.vue?vue&type=template&id=3f4c634e&scoped=true&"
import script from "./SafeForWork3.vue?vue&type=script&lang=js&"
export * from "./SafeForWork3.vue?vue&type=script&lang=js&"
import style0 from "./SafeForWork3.vue?vue&type=style&index=0&id=3f4c634e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4c634e",
  null
  
)

export default component.exports